export const TOGGLE_SIDEBAR = 'UI/TOGGLE_SIDEBAR';
export const SHOW_SIDEBAR = 'UI/SHOW_SIDEBAR';
export const HIDE_SIDEBAR = 'UI/HIDE_SIDEBAR';

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});

export const showSidebar = () => ({
  type: SHOW_SIDEBAR,
});

export const hideSidebar = () => ({
  type: HIDE_SIDEBAR,
});

export const SHOW_MOBILE_NAV = 'UI/SHOW_MOBILE_NAV';
export const HIDE_MOBILE_NAV = 'UI/HIDE_MOBILE_NAV';

export const showMobileNav = () => ({
  type: SHOW_MOBILE_NAV,
});

export const hideMobileNav = () => ({
  type: HIDE_MOBILE_NAV,
});

export const SHOW_UPDATE_SUBSCRIPTION_MODAL = 'UI/SHOW_UPDATE_SUBSCRIPTION_MODAL';
export const HIDE_UPDATE_SUBSCRIPTION_MODAL = 'UI/HIDE_UPDATE_SUBSCRIPTION_MODAL';

export const showUpdateSubscriptionModal = () => ({
  type: SHOW_UPDATE_SUBSCRIPTION_MODAL,
});

export const hideUpdateSubscriptionModal = () => ({
  type: HIDE_UPDATE_SUBSCRIPTION_MODAL,
});

export const PUSH_NOTIFICATION = 'UI/PUSH_NOTIFICATION';

export const pushNotification = ({ title, description, type, duration }) => ({
  type: PUSH_NOTIFICATION,
  payload: {
    title,
    description,
    type,
    duration,
  },
});
